import { Grid, styled } from "@mui/material";
import MxButton2 from "@rf-l1/buttons/MxButton2";
import MxCardPropertySmall from "@rf-l1/cards/property/MxCardPropertySmall";
import MxTypography from "@rf-l1/MxTypography";
import useModal from "@rf/base/modal/useModal";

const PropertyConflictCheckerTemplate = () => {
  const { getData, onClose, onConfirm } = useModal();
  const data = getData() as any;
  return (
    <Grid container>
      <ContentProperties
        item
        xs={12}
        md={8}
        container
        gap={1}
        justifyContent="space-evenly"
      >
        <Grid
          item
          xs={12}
          container
          spacing={1}
          columns={{
            xs: 1,
            md: 2
          }}
        >
          {data.map((x: any, i: number) => (
            <Grid item xs={1} key={i}>
              <MxCardPropertySmall {...x} />
            </Grid>
          ))}
        </Grid>
      </ContentProperties>

      <Grid item xs={12} md={4} container px={1.4} py={0} my={{ xs: 2, md: 0 }}>
        <Grid container item xs={12} alignContent="flex-start">
          <Grid item xs={12} pb={0.5}>
            <MxTypography variant="caption" fontWeight={400} color="grey.600">
              Las siguientes propiedades comparten características similares con la
              que estás agregando actualmente, tales como:
            </MxTypography>
          </Grid>

          <Grid item xs={12} component="ul" marginLeft={-1.5}>
            <Grid item xs={12} component="li">
              <MxTypography variant="caption" fontWeight={400} color="grey.600">
                Ubicación similar
              </MxTypography>
            </Grid>
            <Grid item xs={12} component="li">
              <MxTypography variant="caption" fontWeight={400} color="grey.600">
                Mismo propietario
              </MxTypography>
            </Grid>
            <Grid item xs={12} component="li">
              <MxTypography variant="caption" fontWeight={400} color="grey.600">
                Tipo de propiedad
              </MxTypography>
            </Grid>
          </Grid>
          <Grid item xs={12} pt={1.2}>
            <MxTypography variant="caption" fontWeight={400} color="grey.600">
              Por favor, revise cuidadosamente estos detalles para evitar
              duplicaciones y asegurar la precisión de la información en el sistema.
            </MxTypography>
          </Grid>
        </Grid>

        <Grid
          container
          item
          xs={12}
          columnGap={1}
          justifyContent={"flex-end"}
          alignContent="flex-end"
        >
          <Grid container item xs={12} justifyContent="flex-end" my={1.4}>
            <MxTypography variant="caption" fontWeight={400} color="grey.600">
              ¿Desea continuar?
            </MxTypography>
          </Grid>
          <Grid item xs="auto">
            <MxButton2
              bgColor={"grey.200"}
              textColor={"grey.600"}
              onClick={onClose}
              sx={{
                minWidth: 100
              }}
              testId="no-button"
            >
              No
            </MxButton2>
          </Grid>
          <Grid item xs="auto">
            <MxButton2
              bgColor="primary.main"
              variant="contained"
              onClick={onConfirm}
              sx={{
                minWidth: 100
              }}
              testId="yes-button"
            >
              Si
            </MxButton2>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default PropertyConflictCheckerTemplate;

const ContentProperties = styled(Grid)(({ theme }) => ({
  minHeight: 400,
  maxHeight: 400,
  background: "var(--m-color-gray-01)",
  overflow: "hidden",
  overflowY: "auto",
  padding: "0.5rem",
  [theme.breakpoints.down("md")]: {
    maxHeight: "60vh",
    padding: "0.5rem"
  }
}));
